import axios from "axios";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import ModalUmum from "../../modal/modalUmum/ModalUmum";
import Loading from "../../components/loading/Loading";

function Addspa() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState();
  const [name, setName] = useState("");
  const [pdf, setPdf] = useState("");
  const [image, setImage] = useState("");
  const [modalShow, setModalShow] = useState(false);
  const [title, setTitle] = useState();
  const sizeImage = 1000000;
  const sizePdf = 5000000;

  const addSpa = async () => {
    const data = new FormData();
    data.append("name", name);
    data.append("pdf", pdf);
    data.append("picture", image);

    if (image.size > sizeImage || pdf.size > sizePdf) {
      setTitle("File size is too Big, Maximum size 1MB");
      setModalShow(true);
    } else if (name !== "" && pdf !== "" && image !== "") {
      setLoading(true);
      await axios.post("https://mobile.amospa.com/spa/", data);
      setLoading(false);
      setTitle("Success Add Spa");
      setModalShow(true);
    } else {
      setTitle("fill in all forms");
      setModalShow(true);
    }
  };

  //Handle Next
  const handleNext = async () => {
    setModalShow(false);
    navigate("/homepage/spa/");
  };

  return (
    <div className="container-fluid">
      {loading ? (
        <Loading />
      ) : (
        <div className="row">
          <div className="col-12">
            <div className="wrapper-add-user">
              <div className="wrapper-edit-image">
                <div className="header-edit-image">
                  <h5 className="m-0">Add Spa</h5>
                </div>
                <div className="data-user">
                  <div className="wrapper-data">
                    <label>
                      Name <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      name="name"
                      onChange={(e) => setName(e.target.value)}
                    />
                  </div>
                  <div className="wrapper-data">
                    <label>
                      PDF (Max 5MB)<span className="text-danger">*</span>{" "}
                      <span className="text-danger ms-2">
                        {pdf && pdf.size > sizePdf
                          ? "File size is too Big"
                          : ""}
                      </span>
                    </label>
                    <input
                      style={{ height: "100%" }}
                      type="file"
                      name="pdf"
                      onChange={(e) => setPdf(e.target.files[0])}
                    />
                  </div>
                  <div className="wrapper-data">
                    <label>
                      Picture (Max 1MB)<span className="text-danger">*</span>{" "}
                      <span className="text-danger ms-2">
                        {image && image.size > sizeImage
                          ? "Image size is too Big"
                          : ""}
                      </span>
                    </label>
                    <input
                      style={{ height: "100%" }}
                      type="file"
                      name="picture"
                      onChange={(e) => setImage(e.target.files[0])}
                    />
                  </div>
                  <button onClick={() => addSpa()}>Create Spa</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <ModalUmum
        show={modalShow}
        onHide={() => setModalShow(false)}
        title={title}
        nextButton={
          title !== "fill in all forms" &&
          title !== "File size is too Big, Maximum size 1MB"
            ? handleNext
            : () => setModalShow(false)
        }
      />
    </div>
  );
}

export default Addspa;
